"use strict";

const $ = jQuery;
const LumerisModal = require('./lumeris-modal.js');

module.exports = class {
	#$module;
    #$modal;
    #$trigger;

    #modalId;
    #modal;
    #moduleData = {};
	#modalData = {};

	initialized = false;

	constructor(args={}) {
        if (!args.$module || !args.moduleData || !args.modalData || !args.modalId) {
            return null;
        }

        this.#$module = args.$module;
        this.#moduleData = args.moduleData;
        this.#modalData = args.modalData;
        this.#modalId = args.modalId;
		
        this.#$trigger = this.#$module.find(`[data-lumeris-broker-member-corner-modal="${this.#modalId}"]`);

        this.build();
		this.bind();

		this.initialized = true;
	}

	bind() {	
        this.$trigger.on('click', (event) => { this.onTriggerClick(event); });	
	}

    modalBind() {
        if (!this.modal) {
            return null;
        }

        this.$modal.find('button.modal-download-button').on('click', (event) => { this.onDownloadButtonClick(event); });
        this.modal.on('lumeris-modal:cancelButtonClick', (event) => { this.onCancelButtonClick(event); });
    }

    build() {
        this.modal = new LumerisModal({
            id: this.modalId,
            modalClass: 'lum-broker-member-corner-modal',
            header: this.modalData.download_modal_header,
            cancelButton: true,
			destroyOnCancel: false
        });

        // id: 'lumeris-modal',
        // modalClass: '',
        // modalHeaderClass: '',
        // header: null,
        // headerClass: '',
        // subheader: null,
        // subheaderClass: '',
        // modalBodyClass: '',
        // button: null,
        // buttonClass: '',
        // buttonDisabled: false,
        // altButton: '',
        // altButtonClass: 'no-style',
        // altButtonDisabled: false,
        // modalFooterClass: '',
        // cancelButton: true,
        // backdropClass: '',
        // destroyOnCancel: true

        this.$modal = this.modal.$modal;

        const html = `<div class="mb-3 text-center">
            <select class="modal-download-select">
                <option value="" selected></option>
                ${Object.keys(this.modalData.download_modal_options).map(key => {
                    let option = this.modalData.download_modal_options[key];
                    return `<option value="${option.val}">${option.label}</option>`;
                }).join('')}
            </select>
        </div>
        <div class="text-center">
            <button class="btn btn-primary modal-download-button">Open</button>
        </div>`;

        this.modal.appendBodyContent(html);

        this.modalBind();
    }

    get $module() {
        return this.#$module;
    }

    get $modal() {
        return this.#$modal;
    }

    get $trigger() {
        return this.#$trigger;
    }

    get modal() {
        return this.#modal;
    }

    get modalId() {
        return this.#modalId;
    }

    get moduleData() {
        return this.#moduleData;
    }

    get modalData() {
        return this.#modalData;
    }

    get id() {
        return this.data.node;
    }

    set $modal(val) {
        this.#$modal = val;
    }

    set modal(val) {
        this.#modal = val;
    }

    onTriggerClick(event) {
		if (event instanceof Object === false) {
			return null;
		}

        event.preventDefault();
        
        if (!this.modal) {
            this.build();
        }

        return this.modal.show();
    }

    onDownloadButtonClick(event) {
		if (event instanceof Object === false) {
			return null;
		}

        const $select = this.$modal.find('select.modal-download-select');
        
        if ($select.val() == '') {
            return null;
        }
        
        window.open(new URL($select.val(), window.location.origin).href, '_blank');

        this.modal.hide();

        $select.val('');
    }

    onCancelButtonClick(event) {
		if (event instanceof Object === false) {
			return null;
		}

        this.modal.hide();
	}
}